import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useAuth } from '@/context/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AUTH } from '@/constants/testIds';
import { MapPinned } from 'lucide-react';

export default function Login() {
  const nav = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState('benja.flores.bta@gmail.com');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success('Sesión iniciada');
      nav('/');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div className="hidden md:flex md:w-1/2 relative bg-slate-900" style={{
        backgroundImage: "linear-gradient(135deg, rgba(15,23,42,0.85), rgba(30,58,138,0.85)), url('https://images.pexels.com/photos/1313534/pexels-photo-1313534.jpeg')",
        backgroundSize: 'cover', backgroundPosition: 'center',
      }}>
        <div className="p-12 flex flex-col justify-between text-white w-full">
          <div className="flex items-center gap-2">
            <MapPinned size={22} />
            <span className="font-display font-extrabold text-xl tracking-tight">StrategIA</span>
          </div>
          <div>
            <div className="label-caps text-white/70">Location Intelligence</div>
            <h1 className="font-display text-5xl font-extrabold leading-tight mt-3 tracking-tight">
              Decide dónde<br />abrir tu próxima<br />sucursal.
            </h1>
            <p className="mt-6 text-white/80 max-w-md">
              Inteligencia territorial ejecutiva para México. Analiza ciudades, municipios y regiones con datos de INEGI, DENUE, turismo y señales recientes. Reduce incertidumbre antes de invertir.
            </p>
          </div>
          <div className="text-xs text-white/50">© 2026 StrategIA · Etapa 1</div>
        </div>
      </div>
      <div className="w-full md:w-1/2 flex items-center px-8 md:px-16 py-12 bg-white">
        <form onSubmit={submit} className="w-full max-w-md">
          <div className="label-caps">Acceso ejecutivo</div>
          <h2 className="font-display text-3xl font-bold mt-2 mb-1 tracking-tight">Inicia sesión</h2>
          <p className="text-sm text-slate-500 mb-8">Ingresa a tu cuenta para consultar y crear análisis territoriales.</p>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email">Correo electrónico</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                     data-testid={AUTH.emailInput} required className="mt-1" />
            </div>
            <div>
              <Label htmlFor="password">Contraseña</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                     data-testid={AUTH.passwordInput} required className="mt-1" />
            </div>
          </div>

          <Button type="submit" disabled={loading} data-testid={AUTH.submitBtn}
                  className="w-full mt-6 bg-blue-900 hover:bg-blue-800 h-11 font-semibold">
            {loading ? 'Entrando…' : 'Iniciar sesión'}
          </Button>

          <div className="mt-6 text-sm text-slate-600">
            ¿No tienes cuenta?{' '}
            <Link to="/register" data-testid={AUTH.toRegister} className="text-blue-900 font-semibold hover:underline">
              Crear cuenta
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
